/**
 * CategoryButton Molecule Component
 * Button for selecting vehicle category
 */

import { cn } from '@/lib/utils'

interface CategoryButtonProps {
	id: string
	label: string
	icon: React.ReactNode
	isSelected?: boolean
	onClick?: (id: string) => void
	className?: string
}

export function CategoryButton({
	id,
	label,
	icon,
	isSelected = false,
	onClick,
	className,
}: CategoryButtonProps) {
	return (
		<button
			onClick={() => onClick?.(id)}
			className={cn(
				'flex flex-col items-center justify-center gap-2 px-4 py-5 rounded-xl border-2 transition-all font-["Bricolage_Grotesque"] text-base font-black leading-tight whitespace-pre-line h-full w-full cursor-pointer',
				isSelected
					? 'bg-[#CDFF00] border-[#CDFF00] text-[#09194D]'
					: 'bg-white border-[#09194D] text-[#09194D] hover:border-[#CDFF00]',
				className
			)}
		>
			<div
				className={cn(
					'transition-colors',
					isSelected ? 'text-[#CDFF00]' : 'text-[#09194D]'
				)}
			>
				{icon}
			</div>
			<span className='text-center text-xl'>{label}</span>
		</button>
	)
}
